import {ComponentPropsWithRef, forwardRef, Ref} from 'react';
import {Body1} from '../../typography/body1';
import {IconWrapper, Input, Label, Wrapper} from '../shared';
import {PercentIcon} from '../../icons/percent';
import {InputState} from '../../../interface';
import styled from 'styled-components';

export interface TPercentageInputProps extends ComponentPropsWithRef<'input'> {
  state?: InputState;
  label: string;
  disabled?: boolean;
  compact?: boolean;
}

const PercentageWrapper = styled(Wrapper)<{$compact?: boolean}>`
  height: ${({$compact}) => ($compact ? '44px' : '52px')};
`;

const PercentageLabel = styled(Label)<{$compact?: boolean}>`
  min-width: ${({$compact}) => ($compact ? '44px' : 'auto')};
  padding: ${({$compact}) => ($compact ? '10px' : '12px 8px')};

  ${Body1} {
    font-size: ${({$compact}) => ($compact ? '14px' : 'inherit')};
    line-height: ${({$compact}) => ($compact ? '22px' : 'inherit')};
  }
`;

const CompactPercentageInput = styled(Input)`
  height: 44px;
  padding: 5px 12px;
  font-size: 14px;
  line-height: 22px;
`;

export const PercentageInput = forwardRef(
  (
    {label, id, disabled, state, compact, ...props}: TPercentageInputProps,
    ref: Ref<HTMLInputElement>,
  ) => {
    return (
      <PercentageWrapper
        htmlFor={id}
        disabled={disabled}
        state={state}
        $compact={compact}>
        <PercentageLabel disabled={disabled} $compact={compact}>
          <Body1>{label}</Body1>
        </PercentageLabel>
        {compact ? (
          <CompactPercentageInput
            {...props}
            ref={ref}
            id={id}
            disabled={disabled}
            type="number"
          />
        ) : (
          <Input
            {...props}
            ref={ref}
            id={id}
            disabled={disabled}
            type="number"
          />
        )}
        <IconWrapper disabled={disabled}>
          <PercentIcon />
        </IconWrapper>
      </PercentageWrapper>
    );
  },
);
PercentageInput.displayName = 'PercentageInput';

export const PercentageInputNoIcon = forwardRef(
  (
    {label, id, disabled, state, compact, ...props}: TPercentageInputProps,
    ref: Ref<HTMLInputElement>,
  ) => {
    return (
      <PercentageWrapper
        htmlFor={id}
        disabled={disabled}
        state={state}
        $compact={compact}>
        <PercentageLabel disabled={disabled} $compact={compact}>
          <Body1 style={{margin: '0 12px'}}>{label}</Body1>
        </PercentageLabel>
        {compact ? (
          <CompactPercentageInput
            {...props}
            ref={ref}
            id={id}
            disabled={disabled}
            type="number"
          />
        ) : (
          <Input
            {...props}
            ref={ref}
            id={id}
            disabled={disabled}
            type="number"
            style={{paddingLeft: '16px'}}
          />
        )}
      </PercentageWrapper>
    );
  },
);
PercentageInputNoIcon.displayName = 'PercentageInputNoIcon';

export const KpiPercentageInputNoIcon = forwardRef(
  (
    {
      label,
      id,
      disabled,
      state,
      placeholder,
      compact,
      ...props
    }: TPercentageInputProps,
    ref: Ref<HTMLInputElement>,
  ) => {
    return (
      <PercentageWrapper
        htmlFor={id}
        disabled={disabled}
        state={state}
        $compact={compact}>
        <PercentageLabel disabled={disabled} $compact={compact}>
          <Body1 style={{margin: '0 12px'}}>{label}</Body1>
        </PercentageLabel>
        <div style={{position: 'relative'}}>
          {compact ? (
            <CompactPercentageInput
              {...props}
              ref={ref}
              id={id}
              disabled={disabled}
              type="number"
              onWheelCapture={(e) => {
                e.currentTarget.blur();
              }}
              placeholder={placeholder}
            />
          ) : (
            <Input
              {...props}
              ref={ref}
              id={id}
              disabled={disabled}
              type="number"
              onWheelCapture={(e) => {
                e.currentTarget.blur();
              }}
              style={{paddingLeft: '16px'}}
              placeholder={placeholder}
            />
          )}
          {/* <Body1
            kind="textBody"
            align="center"
            style={{
              position: 'absolute',
              zIndex: 0,
              left: '50%',
              marginLeft: '-25%',
              top: '50%',
              marginTop: '-8%',
            }}>
            {placeholder}
          </Body1> */}
        </div>
      </PercentageWrapper>
    );
  },
);
KpiPercentageInputNoIcon.displayName = 'KpiPercentageInputNoIcon';
